import { z } from 'zod';

// Optional `?ids=uuid,uuid` filter for organisation-scoped list endpoints.
// A non-empty value restricts the result to those ids, letting a caller
// batch-hydrate a known set in one round trip instead of over-fetching the
// whole org. Absent or blank (`?ids=`) normalises to an empty array, which the
// list endpoints treat as "no filter" — the result lists everything, unchanged
// behaviour. The empty-as-unfiltered convention keeps the internal id set a
// plain non-nullable array. The comma-separated form keeps the URL compact for
// the deal surfaces that pass the deduplicated owner / property rosters of the
// rendered page.
export const IdsFilterQuerySchema = z.object({
  ids: z
    .string()
    .optional()
    .transform((value) => (value === undefined || value === '' ? [] : value.split(',')))
    .pipe(z.array(z.uuid())),
});

export type IdsFilterQuery = z.infer<typeof IdsFilterQuerySchema>;
